import { gql } from "@apollo/client";
import { postMessageToLeboncoinExt } from "./leboncoin/LeboncoinExtApi";
import { RequestManagerContextRef } from "../components/common/RequestManager";
import graphqlClient from "../graphqlClient";
import { Lbc_SyncOrderFullfillmentsMutation, Lbc_SyncOrderFullfillmentsMutationVariables } from "../../codegen/graphql";

const LBC_SYNC_ORDER_FULLFILLMENTS_MUTATION = gql`
  mutation LBC_SyncOrderFullfillments($shopId: ID!, $orderId: ID!, $externalOrderId: String!, $externalOrderData: JSON!) {
    syncFromExternalOrder(
      shopId: $shopId,
      shopType: "leboncoin",
      externalOrderId: $externalOrderId,
      externalOrderLang: "fr",
      externalOrderData: $externalOrderData
    ) {
      process {
        id
      }
    }
    syncOrderFullfillments(orderId: $orderId, externalOrderData: $externalOrderData) {
      id
      orderStatus
      shop {
        shopType
      }
      orderFulfillments {
        id
        fullfilledStatus
        fullfilledPlatform
        shippingCarrier
        trackingNumber
      }
    }
  }
`;

export default async function syncLeboncoinOrderFromFrontend(
  shopId: string,
  ourOrderId: string,
  externalOrderId: string,
) {
  const lbcOrderData = await postMessageToLeboncoinExt(window, {
    action: 'get-single-order',
    orderId: externalOrderId,
  })

  const result = await graphqlClient.mutate<Lbc_SyncOrderFullfillmentsMutation, Lbc_SyncOrderFullfillmentsMutationVariables>({
    mutation: LBC_SYNC_ORDER_FULLFILLMENTS_MUTATION,
    variables: {
      shopId: shopId,
      orderId: ourOrderId,
      externalOrderId,
      externalOrderData: lbcOrderData,
    }
  })

  if (!result.data || result.errors) {
    throw result.errors;
  }

 
  const fulfillment = result.data.syncOrderFullfillments.orderFulfillments[0]!;
  if (fulfillment.fullfilledPlatform === 'leboncoin') {
    // Noop, the fulfillment is already synced by leboncoin
    return;
  }

  if (!fulfillment.trackingNumber || !fulfillment.shippingCarrier) {
    // Noop, no shipment yet
    return;
  }

  let freshExternalOrderData = lbcOrderData;

  // Confirm shipment if not already confirmed
  if (lbcOrderData.step.value === 'available') {
    await postMessageToLeboncoinExt(window, {
      action: 'confirm-shipment',
      orderId: externalOrderId,
    });

    freshExternalOrderData = await postMessageToLeboncoinExt(window, {
      action: 'get-single-order',
      orderId: externalOrderId,
    });
  }

  // Add tracking if not already present
  if (
    (
      !lbcOrderData.parcel?.tracking
      || !lbcOrderData.parcel?.custom_tracking
    ) && (
      fulfillment.trackingNumber
      && fulfillment.shippingCarrier
    )
  ) { 
    const parcelId = freshExternalOrderData.tracking_action.parcel_id;
  
    let provider;
    let reference = fulfillment.trackingNumber;
  
    if (fulfillment.fullfilledPlatform === 'aliexpress') {
      provider = 'Cainiao Global';
      reference = fulfillment.trackingNumber;
    }
    else {
      throw new Error('Todo: map more shipping carriers leboncoin shipment')
    }
  
    await postMessageToLeboncoinExt(window, {
      action: 'add-or-edit-tracking',
      parcelId,
      provider,
      reference,
    });
  }
}


export async function syncAllLeboncoinOrdersFromFrontend(
  orders: {
    shopId: string;
    ourOrderId: string;
    externalOrderId: string;
  }[]
) {
  return Promise.all(orders.map(async (order) => {
    return syncLeboncoinOrderFromFrontend(order.shopId, order.ourOrderId, order.externalOrderId);
  }));
}